export default __webpack_public_path__ + "static/media/argon_react_white.b5e91524.png";